<header class="page-header">
  <h1>{{ 'page.contents.name' | translate | upperFirstLetter }}</h1>
  <nav>
    <ul>
      @for (element of menuElements(); track $index) {
      @let isActive = activeElementName() === element.name;
      @let isEmpty = element.count === 0;

      <li [class.active]="isActive" [class.empty]="isEmpty" [class.unselected]="!isActive && !isEmpty"
        (click)="setActiveElement(element)">
        <span class="element-name">{{ 'content_type.' + element.name | translate |upperFirstLetter}}</span>
        <span class="element-count">{{ element.count }}</span>
      </li>
      }
    </ul>
  </nav>
</header>

<div class="outlet">
  <router-outlet />
</div>